import zappy from '@zappy-ride/library.react.components';
import { TermsAndConditionsModal } from './TermsAndConditionsModal';

export * from './TermsAndConditionsModal';

zappy.FactoryInstance.registerComponent(TermsAndConditionsModal);
